import { render, staticRenderFns } from "./QuoteHistory.vue?vue&type=template&id=a4cf0122&scoped=true"
import script from "./QuoteHistory.vue?vue&type=script&lang=js"
export * from "./QuoteHistory.vue?vue&type=script&lang=js"
import style0 from "./QuoteHistory.vue?vue&type=style&index=0&id=a4cf0122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cf0122",
  null
  
)

export default component.exports